import { Box } from '@mui/material'
import { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import selectOptions from '../../constants/selectOptions'
import { IGenericObjectStringValue } from '../../types'
import CardTAG from '../CardTAG'
import DividerTAG from '../DividerTAG'
import Dropdown from '../Dropdown'
import ReportSummary from '../ReportSummary'
import DataPart from './DataPart'
import PageBodyLayout from '../PageBodyLayout'

const CaseOverview: FC = () => {
  const formMethods = useForm<IGenericObjectStringValue>({
    defaultValues: { jumpTo: '' },
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { control, watch } = formMethods
  const jumpToWatchValue = watch('jumpTo')

  useEffect(() => {
    if (jumpToWatchValue) {
      const element: HTMLElement | null = document.querySelector(`#${jumpToWatchValue}`)
      const scrollEl = document.querySelector('.t-page-body')
      if (element && scrollEl) {
        scrollEl?.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - 182, // header + subheader + 36px padding from scrollable el
        })
      }
    }
  }, [jumpToWatchValue])

  return (
    <PageBodyLayout
      className='t-case-overview-page'
      filterPart={
        <CardTAG title='Report Summary'>
          <div className='t-report-card-top'>
            <Dropdown
              label='Jump to Question'
              control={control}
              fieldName='jumpTo'
              selectedValue={jumpToWatchValue}
              options={selectOptions.caseOverviewQuestions}
              placeholder='Select a Question'
            />
          </div>
          <DividerTAG />
          <Box className='t-page-body-left-scrollable-area'>
            <ReportSummary />
          </Box>
        </CardTAG>
      }
      dataPart={<DataPart />}
    />
  )
}

export default CaseOverview
